import React, { PureComponent } from 'react';
import cn from 'classnames';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';
import { FormGroup, Label } from 'reactstrap';
import { array, string, func, node } from 'prop-types';
import { ThemedFMessage } from '../../hoc/IntlComponents';

class DomainTypes extends PureComponent {
  static propTypes = {
    type: string.isRequired,
    types: array.isRequired,
    onTypeChange: func.isRequired,
    error: node,
  };

  static defaultProps = {
    types: [],
    onTypeChange() {},
    error: '',
  };

  render() {
    const { type, types, onTypeChange, error, disabled, theme } = this.props;

    return (
      <FormGroup className={cn({ 'has-error': error }, 'domain-type-formgroup')}>
        <Label for="domain-type">
          <ThemedFMessage id="domain.form.type.label" />
        </Label>
        <Select
          id="domain-type"
          name="type"
          clearable={false}
          value={type}
          placeholder={<FormattedMessage id="main.select" defaultMessage="Select..." />}
          onChange={onTypeChange}
          options={types.map(({ title: label, id: value }) => ({
            value,
            label,
          }))}
          disabled={disabled}
        />
        {error && <small className="form-text">{error}</small>}
      </FormGroup>
    );
  }
}

export default DomainTypes;
